<template>
  <span class="display-field">
    <el-button class="do-btn-four" type="default" icon="el-icon-sort" @click="openDialog">数据顺序</el-button>
    <!-- 设置树结构 -->
    <new-dialog
      class="display-field-modal"
      :newModalVisible="modalVisible"
      @closeNewTask="closeImport"
      modalTitle="数据顺序"
    >
      <template slot="content">
        <el-form
          :model="displayForm"
          ref="displayForm"
          label-width="0"
          :show-message="false"
          @validate="validateValue"
        >
          <div class="display-field-content" v-for="(row, index) in displayForm.rowList" :key="index">
            <el-form-item
            :prop="'rowList.' + index + '.value'"
            :rules="[{ required: displayForm.rowList[index].order, message: '请选择字段名', trigger: 'change'}]"
            style="display:inline-block">
              <el-select class="content-select-one" v-model="displayForm.rowList[index].value" placeholder="请选择">
                <el-option
                  v-for="field in selectList"
                  :label="field.column"
                  :value="field.caseKey"
                  :key="field.key"
                   :disabled="isCanParamsChoose(field)"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
            :prop="'rowList.' + index + '.order'"
            :rules="[{ required: displayForm.rowList[index].value, message: '请选择排序方式', trigger: 'change'}]"
            style="display:inline-block">
              <el-select class="content-select-two" v-model="displayForm.rowList[index].order" placeholder="请选择">
                <el-option
                  v-for="sortItem in sortParamsList"
                  :label="sortItem.label"
                  :value="sortItem.value"
                  :key="sortItem.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <div class="modal-func-icon">
              <el-button
                class="content-icon-del"
                icon="el-icon-minus"
                @click="delItem(row)"
                style="border-radius: 2px"
                v-if="displayForm.rowList.length !== 1"
              ></el-button>
              <el-button
                class="content-icon-add"
                icon="el-icon-plus"
                v-if="index === displayForm.rowList.length - 1 && index<selectList.length -1"
                style="border-radius: 2px"
                @click="addItem(row)"
              ></el-button>
            </div>
          </div>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button class="modal-footer-two" @click="cancel">取消</el-button>
        <el-button class="modal-footer-two" @click="reset">重置</el-button>
        <el-button class="modal-footer-two" type="primary" @click="comfirm">保存</el-button>
      </template>
    </new-dialog>
  </span>
</template>

<script>
import { setStore, getStore } from "@/utils/store";
export default {
  props: {
    selectList: {
      type: Array,
      default: () => []
    },
    sessionOriginalName: {
      type: String,
      default: ""
    },
    sessionResultName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      displayForm: {
        rowList: [
          {
            value: "",
            order: ""
          }
        ]
      },
      rowList: [
        {
          value: "",
          order: ""
        }
      ],
      modalVisible: false,
      sortParamsList: [
        {
          label: "升序",
          value: "ASC"
        },
        {
          label: "降序",
          value: "DESC"
        }
      ],
      countNum: 1
    };
  },
  created() {
    this.getData();
  },
  methods: {
    isCanParamsChoose(item) {
      const value = this.displayForm.rowList.find(el => {
        return el.value === item.caseKey;
      });
      if (value) {
        return true;
      }
      return false;
    },
    // 验证
    validateValue(prop, msgStatus, validateMessage) {
      // console.log(prop, msgStatus, validateMessage)
      if (!msgStatus && !this.countNum) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage)
        }
      }
    },
    reset() {
      this.displayForm.rowList = [
        {
          value: "",
          order: ""
        }
      ];
    },
    getData() {
      if (this.sessionOriginalName) {
        const sortData = getStore({
          name: this.sessionOriginalName,
          type: "session"
        });
        if (sortData && sortData.length) {
          return (this.displayForm.rowList = [...sortData]);
        }
      }
      this.displayForm.rowList = [
        {
          value: "",
          order: ""
        }
      ];
    },
    addItem() {
      this.displayForm.rowList.push({
        value: "",
        order: ""
      });
    },
    comfirm() {
      this.countNum = 0;
      this.$refs.displayForm.validate((valid) => {
        if (valid) {
          setStore({
            name: this.sessionOriginalName,
            content: this.displayForm.rowList,
            type: "session"
          });
          const list = this.displayForm.rowList.filter(el => {
            return el.value && el.order;
          });
          const resolveData = list.map(el => {
            return el.value + " " + el.order;
          });
          setStore({
            name: this.sessionResultName,
            content: resolveData.join(","),
            type: "session"
          });
          this.$emit("setDataOrder", resolveData.join(","));
          this.modalVisible = false;
          this.countNum = 1
        } else {
          return false;
        }
      })
    },
    cancel() {
      this.$refs.displayForm.resetFields();
      this.getData()
      this.modalVisible = false;
    },
    closeImport() {
      // this.cancel()
      this.$refs.displayForm.resetFields();
      this.getData()
      this.modalVisible = false;
    },
    openDialog() {
      this.modalVisible = true;
    },
    // 删除搜索项
    delItem(item) {
      if (this.displayForm.rowList.length !== 1) {
        const itemIndex = this.displayForm.rowList.findIndex(el => {
          return el.value === item.value && el.order === item.order;
        });
        if (itemIndex !== "undefined") {
          this.displayForm.rowList.splice(itemIndex, 1);
        }
      }
    }
  }
};
</script>

<style lang='scss'>
.display-field {
  display: inline-block;
  vertical-align: top;
  .display-field-modal {
    .el-dialog__body {
      text-align: left;
    }
  }
  .display-field-content {
    font-size: 0;
    padding: 4px 0;
    .content-select-one {
      width: 296px;
      margin-right: 4px;
    }
    .content-select-two {
      width: 200px;
    }
    .modal-func-icon {
      display: inline-block;
      margin-left: 8px;
      .el-button {
        width: 13px;
        height: 14px;
        padding: 0 !important;
        margin-left: 0px !important;
      }
      .el-button--medium {
        border-radius: 2px;
      }
      .content-icon-del {
        border: 1px solid #ff3b30;
        color: #ff3b30;
      }
      .content-icon-add {
        margin-left: 16px !important;
        border: 1px solid #3296fa;
        color: #3296fa;
      }
    }
  }
}
</style>
